import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./Home";
import Product from "./Product";
import ContactUs from "./ContactUs";
// import Login from "./Login";
// import Registration from "./Registration";
// import ForgotPassword from "./ForgotPassword";
import Admin from "./Admin/Admin";
import Addproduct from "./Admin/Addproduct";
import RegisFoemk from "./RegisFoemk";
import LoginAdmin from "./Admin/LoginAdmin";
import ProductsTable from "./Admin/ProductsTable";
import ProductDetails from "./ProductDetails";
import ClientOrder from "./Admin/ClientOrder";
import InquiryFormData from "./Admin/InquiryFormData";
import ContactFormData from "./Admin/ContactFormData";
import BlogPage from "./BlogPage";
import BlogDetails from "./BlogDetails";
import AddBlog from "./Admin/AddBlog";
import BlogTable from "./Admin/BlogTable";
import Error404 from "./Error404";
import TermsAndConditions from "./TermsAndConditions";
import PrivacyPolicy from "./PrivacyPolicy";
import ReturnsAndExchanges from "./ReturnsAndExchanges";
import BillingAndShippingPolicy from "./Shippingandbillingpolicy";
import FAQs from "./FAQs";
import CookiePolicy from "./CookiePolicy";
import { DataProvider } from "./DataContext";

const Routercontaner = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("isAuthenticated") === "true" ? true : false
  );

  const PrivateRoute = ({ element }) => {
    return isAuthenticated ? element : <Navigate to="/LoginAdmin" replace />;
  };

  const PageOpenFromTop = () => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };

  return (
    <DataProvider>
      <BrowserRouter>
        <PageOpenFromTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/contact" element={<ContactUs />} />
          {/* <Route path="/login" element={<Login />} />
          <Route path="/registration" element={<Registration />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/regis" element={<RegisFoemk />} />
          <Route path="/product-details/:id" element={<ProductDetails />} />
          <Route path="/terms-conditions" element={<TermsAndConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/billing-shipping-policy" element={<BillingAndShippingPolicy />} />
          <Route path="/return-exchange-policy" element={<ReturnsAndExchanges />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin" element={<Navigate to="/Admin/ProductsTable" />} />
          <Route
            path="/LoginAdmin"
            element={<LoginAdmin setAuth={setIsAuthenticated} />}
          />
          <Route
            path="/Admin/*"
            element={
              <PrivateRoute
                element={<Admin setIsAuthenticated={setIsAuthenticated} />}
              />
            }
          >
            <Route path="ProductsTable" element={<ProductsTable />} />
            <Route path="Addproduct" element={<Addproduct />} />
            <Route path="AddBlog" element={<AddBlog />} />
            <Route path="BlogTable" element={<BlogTable />} />
            <Route path="ClientOrder" element={<ClientOrder />} />
            <Route path="InquiryFormData" element={<InquiryFormData />} />
            <Route path="ContactFormData" element={<ContactFormData />} />
          </Route>
          <Route path="*" element={<Error404 />} />
        </Routes>
      </BrowserRouter>
    </DataProvider>
  );
};

export default Routercontaner;
